import "./series/create.js.coffee";
import "./series/series.js.coffee";
